import axiosVerbose from './axios/axiosVerbose'

/**
 * Get shopfront jwt token with given sso token
 * @return {String} jwt token
 */
const getSession = () => {
  return axiosVerbose.get('/jwt_session')
}

export {
  getSession
}



// WEBPACK FOOTER //
// ./common/utils/auth.js